// extracted by mini-css-extract-plugin
export var survey = "survey-page-module--survey--2Al6u";
export var wrapper = "survey-page-module--wrapper--9UJEs";